import React, { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { useBlockCompany } from "../../hooks/useBlockCompany";

const BlockCompanyModal = ({ show, onHide, companyId, isBlocked, onUnblock }) => {
  const [reason, setReason] = useState("");
  const { mutate: blockCompany, isPending: isBlocking } = useBlockCompany();

  const handleBlock = (e) => {
    e.preventDefault();
    blockCompany(
      {
        companyId,
        body: { reason: reason || undefined },
      },
      {
        onSuccess: () => {
          setReason("");
          onHide();
        },
      }
    );
  };

  const handleUnblock = () => {
    onUnblock(companyId);
    onHide();
  };

  const handleClose = () => {
    setReason("");
    onHide();
  };

  if (isBlocked) {
    return (
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Unblock Company</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning">
            Are you sure you want to unblock this company? This will restore their access to the application.
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleUnblock}>
            Unblock Company
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Block Company</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleBlock}>
        <Modal.Body>
          <Alert variant="danger">
            Blocking a company will prevent them from accessing the application. This action can be reversed later.
          </Alert>
          <Form.Group className="mb-3">
            <Form.Label>Reason for Blocking (Optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter reason for blocking this company"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={isBlocking}>
            Cancel
          </Button>
          <Button variant="danger" type="submit" disabled={isBlocking}>
            {isBlocking ? "Blocking..." : "Block Company"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default BlockCompanyModal;

